import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorFrequency,
  fetchProcessorFrequencyAttributes,
  fetchProcessorFrequencyById,
  updateProcessorFrequency,
  updateStatusInProcessorFrequency,
} from "./thunk";

interface CategoryState {
  processor_frequnecy_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_frequnecy_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_frequnecy",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorFrequencyAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorFrequencyAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_frequnecy_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorFrequencyAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorFrequencyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorFrequencyById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorFrequencyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorFrequency.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_frequnecy_list = state.processor_frequnecy_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(addProcessorFrequency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorFrequency.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_frequnecy_list = state.processor_frequnecy_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(updateProcessorFrequency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorFrequency.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorFrequency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
